'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _ComponentWithUniqueIds = require('../mixins/ComponentWithUniqueIds');

var _ComponentWithUniqueIds2 = _interopRequireDefault(_ComponentWithUniqueIds);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _UIFormLabel = require('../form/UIFormLabel');

var _UIFormLabel2 = _interopRequireDefault(_UIFormLabel);

var _UICheckbox = require('../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _elements = require('../elements');

var _underscore = require('../utils/underscore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Group a form field, label, notes, and errors/alerts together
 **/
exports.default = _react2.default.createClass({
  displayName: 'UIFormControl',

  mixins: [_ComponentWithUniqueIds2.default],

  propTypes: {
    /**
     * Instructional text to display with the field label
     **/
    'aria-label': _react.PropTypes.string,
    /**
     * Pass the form input as a child. Label will be linked by provided ID, or
     * a random unique ID will be assigned to the input for linking.
     **/
    children: _react.PropTypes.node.isRequired,

    className: _react.PropTypes.string,

    /**
     * Detailed description of component. Similar to `help` but more in-depth
     **/
    description: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.bool]),

    /**
     * `true` indicates this field is in an error state
     * DEPRECATED: or pass an error string to have it displayed at the bottom of the input
     **/
    error: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.node]),

    /**
     * Message to be displayed at the bottom of the input
     *
     * By default the text is green
     * If `error` is set to `true` then the text is red
     **/
    validationMessage: _react.PropTypes.node,

    /**
     * Instructional text to display with the field label
     **/
    help: _react.PropTypes.node,

    /**
     * `id` attribute of the input field you want label to be bound to
     *
     * By default, the `<label />` will be linked to the embedded `<input />`
     * using the `for` attribute. Use this if you need to override that behavior
     **/
    htmlFor: _react.PropTypes.string,

    /**
     * Renders a clickable <UIFormLabel /> alongside input with this text as content
     **/
    label: _react.PropTypes.node,

    /**
     * Class name for the rendered <UIFormLabel /> component
     **/
    labelClassName: _react.PropTypes.string,

    /**
     * `true` indicates the field is required and will be styled accordingly
     **/
    required: _react.PropTypes.bool.isRequired,

    /**
     * Instructional text to display with the the '?' icon and tooltip
     **/
    tooltip: _react.PropTypes.node,

    /**
     * Placement of the tooltip
     **/
    tooltipPlacement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      tooltipPlacement: 'top'
    };
  },
  getHtmlFor: function getHtmlFor(propValue, children) {
    var firstChild = _react.Children.only(children);

    if (propValue) {
      return propValue;
    }

    if (firstChild) {
      var _firstChild$props = firstChild.props,
          name = _firstChild$props.name,
          id = _firstChild$props.id;

      return id || name;
    }

    return null;
  },
  getClasses: function getClasses(_ref) {
    var className = _ref.className,
        description = _ref.description,
        error = _ref.error,
        label = _ref.label;

    return (0, _reactUtils.classNames)('private-form__set', className, {
      'private-form__set--error': !!error,
      'private-form__set--with-details': !!description,
      'private-form__set--no-label': !label
    });
  },
  renderValidation: function renderValidation(_ref2) {
    var error = _ref2.error,
        validationMessage = _ref2.validationMessage;

    var validationClass = 'private-form__validation';

    if (validationMessage) {
      return _react2.default.createElement(
        _elements.Small,
        {
          className: validationClass,
          use: error ? 'error' : 'success'
        },
        validationMessage
      );
    }

    if (error && (0, _underscore.isString)(error)) {
      _devLogger2.default.warn({
        message: 'UIFormControl: Use of error property as a string is deprecated, please use' + ' `validationMessage` paired with a boolean value for `error` instead.',
        key: 'UIFormControl: error string'
      });

      return _react2.default.createElement(
        _elements.Small,
        {
          className: validationClass,
          use: 'error'
        },
        error
      );
    }

    return null;
  },
  renderTooltip: function renderTooltip(_ref3) {
    var tooltip = _ref3.tooltip,
        tooltipPlacement = _ref3.tooltipPlacement;

    if (!tooltip) return null;
    return _react2.default.createElement(
      _UITooltip2.default,
      {
        placement: tooltipPlacement,
        title: tooltip },
      _react2.default.createElement(_UIIcon2.default, {
        className: 'private-form__help-tooltip',
        name: _icons2.default.INFO,
        tabIndex: 0
      })
    );
  },
  renderHelp: function renderHelp(_ref4, _ref5) {
    var help = _ref4.help;
    var renderedInput = _ref5.renderedInput;

    var labelledBy = renderedInput && renderedInput.props && renderedInput.props.id;
    if (help) {
      return _react2.default.createElement(
        'span',
        {
          'aria-labelledby': labelledBy,
          className: 'private-form__inlinehelp' },
        help
      );
    }

    return null;
  },
  renderDescription: function renderDescription(_ref6) {
    var description = _ref6.description;

    if (!description) return null;

    return _react2.default.createElement(
      'div',
      { className: 'private-form__desc' },
      _react2.default.createElement(
        _elements.Small,
        { use: 'help' },
        description
      )
    );
  },
  renderInput: function renderInput(_ref7) {
    var ariaLabel = _ref7.ariaLabel,
        children = _ref7.children,
        error = _ref7.error,
        required = _ref7.required;

    var child = _react.Children.only(children);
    var _child$props = child.props,
        id = _child$props.id,
        name = _child$props.name,
        origRequired = _child$props.required;

    // only add id prop if input doesn't have it already
    // or if both name and id are empty, bail and just return as-is

    var newId = id != null ? id : this.getUniqueId(name || 'ctrl');

    // if the child input doesn't declare `required`, pass it down
    var newRequired = required === true ? true : origRequired;

    var cloneProps = {
      'aria-label': ariaLabel,
      id: newId,
      required: newRequired,
      'aria-required': newRequired
    };
    // only add error prop if there is an error, to avoid potential "Unknown prop" warnings
    if (error) {
      cloneProps.error = !!error;
    }
    return (0, _react.cloneElement)(child, cloneProps);
  },
  renderLabel: function renderLabel(_ref8, _ref9) {
    var ariaLabel = _ref8.ariaLabel,
        children = _ref8.children,
        label = _ref8.label,
        labelClassName = _ref8.labelClassName,
        error = _ref8.error,
        htmlFor = _ref8.htmlFor,
        required = _ref8.required;
    var renderedInput = _ref9.renderedInput;

    if (!label && !ariaLabel && _react.Children.only(children).type !== _UICheckbox2.default) {
      _devLogger2.default.warn({
        message: 'UIFormControl: For better accessibility, if you\'re going to omit `label`, please include an `aria-label` property.',
        key: 'UIFormControl: add aria-label'
      });
    }

    if (!label) return null;

    return _react2.default.createElement(
      _UIFormLabel2.default,
      {
        className: labelClassName,
        error: !!error,
        htmlFor: this.getHtmlFor(htmlFor, renderedInput),
        required: required },
      label
    );
  },
  render: function render() {
    var _props = this.props,
        ariaLabel = _props['aria-label'],
        children = _props.children,
        className = _props.className,
        description = _props.description,
        error = _props.error,
        validationMessage = _props.validationMessage,
        help = _props.help,
        htmlFor = _props.htmlFor,
        label = _props.label,
        labelClassName = _props.labelClassName,
        required = _props.required,
        tooltip = _props.tooltip,
        tooltipPlacement = _props.tooltipPlacement,
        rest = _objectWithoutProperties(_props, ['aria-label', 'children', 'className', 'description', 'error', 'validationMessage', 'help', 'htmlFor', 'label', 'labelClassName', 'required', 'tooltip', 'tooltipPlacement']);

    var classes = this.getClasses({ className: className, description: description, error: error, label: label });
    var renderedInput = this.renderInput({ ariaLabel: ariaLabel, children: children, error: error, required: required });

    return _react2.default.createElement(
      'div',
      _extends({
        className: classes
      }, rest),
      _react2.default.createElement(
        'div',
        { className: 'private-form__control-wrapper' },
        this.renderLabel({ ariaLabel: ariaLabel, children: children, label: label, labelClassName: labelClassName, error: error, htmlFor: htmlFor, required: required }, { renderedInput: renderedInput }),
        this.renderTooltip({ tooltip: tooltip, tooltipPlacement: tooltipPlacement }),
        this.renderHelp({ help: help }, { renderedInput: renderedInput }),
        _react2.default.createElement(
          'div',
          { className: 'private-form__input-wrapper' },
          renderedInput
        ),
        this.renderValidation({ error: error, validationMessage: validationMessage })
      ),
      this.renderDescription({ description: description })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/legacy/UIFormControl.js
// module id = 139
// module chunks = 0 1